import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import type { IActionItem } from '@model/actionItem';

import { apiClient } from '@services/apiClient';

const AVAILABLE_AI_COUNT = 3;

export const sensorAiByInstPointKey = (pointId?: string) => ['sensorAiByInstPoint', pointId];

export const sensorAiByInstPointFn = ({ queryKey }: QueryFunctionContext<(string | number)[]>) =>
  apiClient.get(`${APP_API_URL_V2}fsd/action-item/list/by-installation-point/${queryKey[1]}`);

const sensorAiByInstPointSelect = ({ data }: AxiosResponse<{ data: IActionItem[] }>) => {
  const aiList = data?.data?.slice(0, AVAILABLE_AI_COUNT) || [];

  return { list: aiList, showViewAll: data?.data?.length > AVAILABLE_AI_COUNT };
};

export const useSensorAiByInstPointQuery = ({ pointId }: { pointId?: string }) => {
  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: sensorAiByInstPointKey(pointId),
    queryFn: sensorAiByInstPointFn,
    enabled: !!pointId,
    select: sensorAiByInstPointSelect,
  });
};
